import {Injectable} from '@angular/core';
import {applicationStatus} from '../../compare/compare.service';
import {LoanComponent} from '../../../loanApplication/loan/loan.component';
import {DetailsComponent} from '../../../loanApplication/details/details.component';
import {ResidenceDetailsComponent} from '../../../loanApplication/residence-details/residence-details.component';
import {EmployeeDetailsComponent} from '../../../loanApplication/employeeDetails/employeeDetails.component';
import {StatusComponent} from '../../../loanApplication/status/status.component';
import {KycComponent} from '../../../loanApplication/kyc/kyc.component';
import {VerifyDetailsComponent} from '../../../loanApplication/verify-details/verify-details.component';
import {SentLinkComponent} from '../../../loanApplication/sent-link/sent-link.component';

@Injectable({
    providedIn: 'root'
})
export class StateTransitionsService {

    constructor() {
    }

    findAllowedRoute(loanDetails: any) {
        return {
            [applicationStatus.LOAN_DETAILS]: `details`,
            [applicationStatus.LOAN_DETAILS]: `viewDetails`,
            [applicationStatus.USER_BASIC_DETAILS]: 'residence-details',
            [applicationStatus.RESIDENCE_DETAILS]: 'employeeDetails',
            [applicationStatus.CIBIL_APPLIED]: 'status',
            [applicationStatus.CIBIL_PROGRESS]: 'status',
            [applicationStatus.CIBIL_APPROVED]: loanDetails && loanDetails.completedPartnerFlow ? 'sentLink' : 'status',
            [applicationStatus.CUSTOMER_INIT]: 'status',
            [applicationStatus.PAYMENT_DONE]: 'status',
            [applicationStatus.ENACH_ENABLED]: 'status',
            [applicationStatus.APPLICATION_SUBMITTED]: 'status',
            [applicationStatus.DISBURSED]: 'status',
            [applicationStatus.REJECTED]: 'status',
            [applicationStatus.CANCELLED]: 'status'
        }[loanDetails.applicationStatus] || null;
    }

    isRequestedRouteAllowed(requestedComponent: any, loanDetails: any) {

        if (requestedComponent === LoanComponent) {
            return [
                    applicationStatus.LOAN_DETAILS,
                    applicationStatus.USER_BASIC_DETAILS,
                    applicationStatus.RESIDENCE_DETAILS,
                ].indexOf(loanDetails.applicationStatus) !== -1
                || (loanDetails.applicationStatus === applicationStatus.CIBIL_APPROVED
                    && (loanDetails.eligibleAmount && loanDetails.eligibleAmount > loanDetails.loanAmount));
        }

        if (requestedComponent === DetailsComponent) {
            return [
                applicationStatus.LOAN_DETAILS,
                applicationStatus.USER_BASIC_DETAILS,
                applicationStatus.RESIDENCE_DETAILS,
            ].indexOf(loanDetails.applicationStatus) !== -1;
        }

        if (requestedComponent === ResidenceDetailsComponent) {
            return [
                applicationStatus.USER_BASIC_DETAILS,
                applicationStatus.RESIDENCE_DETAILS,
            ].indexOf(loanDetails.applicationStatus) !== -1;
        }
        if (requestedComponent === EmployeeDetailsComponent) {
            return [
                applicationStatus.RESIDENCE_DETAILS,
            ].indexOf(loanDetails.applicationStatus) !== -1;
        }
        if (requestedComponent === StatusComponent) {
            return [
                applicationStatus.CIBIL_APPLIED,
                applicationStatus.CIBIL_PROGRESS,
                applicationStatus.CIBIL_APPROVED,
                applicationStatus.CUSTOMER_INIT,
                applicationStatus.CANCELLED,
                applicationStatus.DISBURSED,
                applicationStatus.REJECTED,
            ].indexOf(loanDetails.applicationStatus) !== -1;
        }
        if (requestedComponent === SentLinkComponent) {
            return [applicationStatus.CIBIL_APPROVED].indexOf(loanDetails.applicationStatus) !== -1;
        }

        return false;
    }
}
